<template>
  <table class="text-center">
    <thead>
      <tr style="color: white;">
        <th rowspan="2">{{$t('NIVEL')}}</th>
        <th colspan="2">PROBABILIDAD</th>
      </tr>
      <tr style="background-color: rgb(201, 228, 227);">
        <th>{{$t('CUALITATIVO')}}</th>
        <th>{{$t('CUANTITATIVO')}}</th>
      </tr>
    </thead>
    <tbody>
      <tr v-bind:key="i" v-for="(prob, i) in probabilidades" :class="{'fondo-impar': validPar(i) === false, 'fondo-par': validPar(i) === true}">
        <td>
          <b>{{ prob.likelihoodFactor }}</b>
          <br />
          {{ prob.uncertainty }}
        </td>
        <td @click="click(prob.likelihoodFactor)">{{ prob.cuantitativo }}</td>
        <td @click="click(prob.likelihoodFactor)">{{ prob.cualitativo }}</td>
      </tr>
    </tbody>
  </table>
</template>

<script>
export default {
  name: "TablaProbabilidad",
  props: ["click"],
  data() {
    return {
      probabilidades: [
        {
          uncertainty: this.$t("Casi Cierto"),
          cuantitativo: this.$t("Una vez a la semana."),
          cualitativo: this.$t("Pasa a menudo."),
          likelihoodFactor: 5
        },
        {
          uncertainty: this.$t("Probable"),
          cuantitativo: this.$t("Una vez al mes o más."),
          cualitativo: this.$t(
            "Podría suceder fácilmente y ha ocurrido generalmente en condiciones similares."
          ),
          likelihoodFactor: 4
        },
        {
          uncertainty: this.$t("Posible"),
          cuantitativo: this.$t("Una o dos veces al año."),
          cualitativo: this.$t(
            "Podría suceder y ha sucedido en condiciones similares aquí o en otra compañía."
          ),
          likelihoodFactor: 3
        },
        {
          uncertainty: this.$t("Poco Probable"),
          cuantitativo: this.$t("Una o dos veces cada 10 años."),
          cualitativo: this.$t("No ha sucedido todabía pero podría suceder."),
          likelihoodFactor: 2
        },
        {
          uncertainty: this.$t("Muy Poco Probable"),
          cuantitativo: this.$t("Una o dos veces cada 50 años."),
          cualitativo: this.$t("Sólo en circunstancias extremas."),
          likelihoodFactor: 1
        }
      ]
    };
  },
  methods: {
    validPar(valor) {
      return (valor%2)? true : false;
    }
  }
};
</script>

<style scoped>
.fondo-impar {
  background-color: rgb(162, 211, 210);
}
.fondo-par {
  background-color: rgb(201, 228, 227);
}
table {
  border-collapse: collapse;
}
thead tr:nth-child(1) {
  background-color: rgb(7, 116, 141);
}
thead tr:nth-child(2) {
  background-color: white;
}
td,
th {
  padding: 10px;
  border: 1px solid #454545;
}
td:nth-child(2),
td:nth-child(3) {
  padding: 15px;
}
td:nth-child(2):hover,
td:nth-child(3):hover {
  cursor: pointer;
  transition: 0.5s background-color;
  background-color: #ececec;
}
</style>
